module.exports = __webpack_public_path__ + "static/media/vip-entry-locked.f9f17e83.png";